/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Open_Source_ToolsInputs */

const en_directory_launch_open_source_tools = /** @type {(inputs: Directory_Launch_Open_Source_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open-source tools`)
};

const zh_directory_launch_open_source_tools = /** @type {(inputs: Directory_Launch_Open_Source_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源工具`)
};

/**
* | output |
* | --- |
* | "Open-source tools" |
*
* @param {Directory_Launch_Open_Source_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_open_source_tools = /** @type {((inputs?: Directory_Launch_Open_Source_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Open_Source_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_open_source_tools(inputs)
	return zh_directory_launch_open_source_tools(inputs)
});
export { directory_launch_open_source_tools as "directory.launch.open_source_tools" }